import React from 'react';
import { mergeStyles } from '@fluentui/react';
import { MicrophoneIcon, RaisedHandIcon } from '../Icons';
import { RaisedHand } from '@azure/communication-react';
import { NotificationIcon } from '../NotificationIcon';
import { NumberOfParticipantsIcon } from '../Icons/NumberOfParticipantsIcon';

const overlayContainerStyles = mergeStyles({
    position: 'absolute',
    height: '50px',
    top: 0,
    left: 0,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    pointerEvents: 'none', // allows clicks to pass through
    padding: '4px',
    boxSizing: 'border-box',
    flexDirection: 'row',
    alignItems: 'center',
});

const leftAreaStyles = mergeStyles({
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
});

const rightAreaStyles = mergeStyles({
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
});

const numberOfParticipantsContainerStyles = mergeStyles({
    borderRadius: '4px',
    background: 'rgba(0, 0, 0, 0.50)',
    padding: '0 4px',
    color: 'white',
    display: 'flex',
    alignItems: 'center'
});

const raisedHandIconStyles = {
    root: {
        '--raise-hand-icon-size': `50px`,
    },
    container: {
        '--raise-hand-icon-container-size': `24px`,
        backgroundColor: '#FFFFFF'
    },
};

const notificationIconStyles = {
    root: {
        transform: "translateX(-50%) translateY(-50%)"
    }
};

interface VideoTileIndicatorsOverlayProps {
    isSpeaking?: boolean;
    isMuted?: boolean;
    raisedHand?: RaisedHand;
    numberOfParticipants?: number;
}

export const VideoTileIndicatorsOverlay = React.memo((props: VideoTileIndicatorsOverlayProps): JSX.Element => {
    const { raisedHand, isSpeaking, isMuted, numberOfParticipants } = props;

    return (
        <div className={overlayContainerStyles}>

            {/* Left area: all left-aligned icons */}
            <div className={leftAreaStyles}>
                {raisedHand && (
                    <RaisedHandIcon styles={raisedHandIconStyles}>
                        {raisedHand.raisedHandOrderPosition && (
                            <NotificationIcon
                                chatMessagesCount={raisedHand.raisedHandOrderPosition}
                                label={'Hand erhoben'}
                                size={'small'}
                                horizontalAlign={'left'}
                                styles={notificationIconStyles}
                            />
                        )}
                    </RaisedHandIcon>
                )}
                {numberOfParticipants && (
                    <div className={numberOfParticipantsContainerStyles}>
                        <NumberOfParticipantsIcon numberOfParticipants={numberOfParticipants} />
                    </div>
                )}
            </div>

            {/* Right area: all right-aligned icons */}
            <div className={rightAreaStyles}>
                <MicrophoneIcon
                    speaking={isSpeaking}
                    muted={isMuted}
                />
            </div>
        </div>
    );
});
